import React, { useState } from "react";
import "./ContactMe.css";

import { notification } from "antd";

import {
  FacebookOutlined,
  LinkedinOutlined,
  GlobalOutlined,
  InstagramOutlined,
  WhatsAppOutlined,
  GithubOutlined,
} from "@ant-design/icons";

import { db } from "../FirebaseAdd";
import { collection, addDoc } from "firebase/firestore";

export default function ContactMe() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [subject, setSubject] = useState("");
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false); // State variable for loader

  const [charCount, setCharCount] = useState(0);

  const [api, contextHolder] = notification.useNotification();

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const handleSubmit = async () => {
    if (!email.trim()) {
      openNotificationWithIcon(
        "error",
        "Error",
        "Please provide an email address."
      );
    } else if (
      !name.trim() ||
      !phone.trim() ||
      !subject.trim() ||
      !comment.trim()
    ) {
      openNotificationWithIcon(
        "warning",
        "Warning",
        "Please fill in all fields."
      );
    } else if (!isValidEmail(email)) {
      openNotificationWithIcon(
        "error",
        "Error",
        "Please provide a valid email address."
      );
    } else {
      setLoading(true);
      try {
        const usersCollectionRef2 = collection(db, "contact");
        await addDoc(usersCollectionRef2, {
          name: name,
          email: email,
          phone: phone,
          subject: subject,
          comment: comment,
        });
        setLoading(false);
        openNotificationWithIcon(
          "success",
          "Success",
          "Your message has been submitted successfully!"
        );
        // Clear input fields after successful submission
        setName("");
        setEmail("");
        setPhone("");
        setSubject("");
        setComment("");
        setCharCount(0);
      } catch (error) {
        console.error("Error adding document: ", error);
        setLoading(false);
        openNotificationWithIcon(
          "error",
          "Error",
          "An error occurred while submitting your message. Please try again later."
        );
      }
    }
  };

  const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };

  return (
    <div className="ContactMe-Body">
      {contextHolder}
      <div className="ContactMe-Box">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4766.511668413293!2d90.3727544895829!3d23.802135408369725!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c0d33532b3fb%3A0x2b27b0c01cb2bc0d!2sMirpur-10%2C%20Dhaka!5e0!3m2!1sen!2sbd!4v1715859353523!5m2!1sen!2sbd"
          width="100%"
          height="450"
          frameBorder="0"
          style={{ border: "0", outline: "none" }}
          allowFullScreen
          loading="lazy"
        ></iframe>
        <div className="ContactMe-Div">
          <div className="ContactMe-Left">
            <div className="ContactMe-Div-Left">
              <div className="ContactMe-Left-Box">
                <p className="ContactMe-Left-Text1">Phone:</p>
                <a href="tel:01580-233165" className="ContactMe-Left-aTag">
                  01580-233165
                </a>
              </div>

              <div className="ContactMe-Left-Box">
                <p className="ContactMe-Left-Text1">Email:</p>
                <a
                  href="mailto:tasnimshahriarakash@gmail.com"
                  className="ContactMe-Left-aTag"
                >
                  tasnimshahriarakash@gmail.com
                </a>
              </div>

              <div className="ContactMe-Left-Box">
                <p className="ContactMe-Left-Text1">Website:</p>
                <a
                  href="https://my-portfolio-d43ec.web.app/"
                  target="blank"
                  className="ContactMe-Left-aTag"
                >
                  Tasnim Shahriar Akash
                </a>
              </div>

              <div className="ContactMe-Left-Box">
                <p className="ContactMe-Left-Text1">Address:</p>
                <a className="ContactMe-Left-aTag">
                  Mirpur-10, Dhaka, Bangladesh
                </a>
              </div>
            </div>

            <div className="ContactMe-Left-Bottom">
              <div className="ContactMe-LBottom-Box">
                <p className="ContactMe-Left-Text2">Follow Me</p>
                <div className="ContactMe-LBottom-Div">
                  <a
                    className="ContactMe-Left-aTag2"
                    href="https://www.facebook.com/tasnimSakash/"
                    target="blank"
                  >
                    <FacebookOutlined />
                  </a>

                  <a
                    className="ContactMe-Left-aTag2"
                    href="https://www.instagram.com/tasnim_shahriar_akash?utm_source=qr%2F"
                    target="blank"
                  >
                    <InstagramOutlined />
                  </a>

                  <a
                    className="ContactMe-Left-aTag2"
                    href="https://api.whatsapp.com/send?phone=8801580233165&text=hello%F0%9F%98%87"
                    target="blank"
                  >
                    <WhatsAppOutlined />
                  </a>
                </div>

                <div className="ContactMe-LBottom-Div">
                  <a
                    className="ContactMe-Left-aTag2"
                    href="https://www.linkedin.com/in/tasnimsakash/"
                    target="blank"
                  >
                    <LinkedinOutlined />
                  </a>

                  <a
                    className="ContactMe-Left-aTag2"
                    href="https://github.com/akashsdk"
                    target="blank"
                  >
                    <GithubOutlined />
                  </a>

                  <a
                    className="ContactMe-Left-aTag2"
                    href="https://my-portfolio-d43ec.web.app/"
                    target="blank"
                  >
                    <GlobalOutlined />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="ContactMe-Div-Right">
            <p className="ContactMe-Right-Text1">|| Get In Touch</p>
            <p className="ContactMe-Right-Text2">
              If you have any project or need help, contact me.
            </p>
            <p className="ContactMe-Right-Text3">
              Lorem Ipsum is simply dummy text of the printing and typesetting
              industry. Lorem Ipsum has been the industry's standard dummy text
              ever since the 1500s, when an unknown printer took a galley of
              type and scrambled it to make a type specimen book.
            </p>

            <div className="ContactMe-Right-Box">
              <input
                placeholder="Name"
                className="ContactMe-Right-Input"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <input
                placeholder="Email"
                className="ContactMe-Right-Input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            <div className="ContactMe-Right-Box">
              <input
                placeholder="Phone"
                className="ContactMe-Right-Input"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
              <input
                placeholder="Subject"
                className="ContactMe-Right-Input"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
              />
            </div>

            <textarea
              placeholder="Comment"
              className="ContactMe-Right-textarea"
              maxLength={1000}
              value={comment}
              onChange={(e) => {
                setComment(e.target.value);
                setCharCount(e.target.value.length);
              }}
            />

            <p className="char-counter">{charCount} / 1000</p>

            <button
              className="ContactMe-Right-Button"
              onClick={handleSubmit}
              disabled={loading} 
            >
              {loading ? "Submitting..." : "Submit Message"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
